import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { ImpersonationBanner } from '../admin/ImpersonationBanner';
import { useSidebarState } from '../../hooks/useSidebarState';

const Layout: React.FC = () => {
  const {
    isCollapsed,
    isMobileOpen,
    toggleCollapsed,
    openMobile,
    closeMobile,
  } = useSidebarState();

  const isMobile = window.innerWidth < 768;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <Sidebar
        isCollapsed={isCollapsed}
        onToggle={toggleCollapsed}
        isMobileOpen={isMobileOpen}
        onMobileClose={closeMobile}
      />

      {/* Main Content Area */}
      <div
        className="flex flex-col flex-1 min-h-screen transition-all duration-250"
        style={{
          marginLeft: isMobile ? 0 : isCollapsed ? '80px' : '256px',
        }}
      >
        <Header onMobileMenuClick={openMobile} />
        <ImpersonationBanner />
        <main className="flex-1 container mx-auto px-4 py-6 lg:px-8">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
